"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const config_1 = __importDefault(require("../config"));
class Logger {
    static handle(err) {
        console.error(err);
    }
    static error(err) {
        console.error(Logger.prefixText(err));
    }
    static warn(warn) {
        if (config_1.default.debug) {
            console.warn(Logger.prefixText(warn));
        }
    }
    static info(txt) {
        if (config_1.default.debug) {
            console.info(Logger.prefixText(txt));
        }
    }
    static prefixText(txt) {
        return `${Logger.prefix}: ${txt}`;
    }
}
exports.Logger = Logger;
Object.defineProperty(Logger, "prefix", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'GAL'
});
